<template>
  <div class="container">
    <span class="title">{{ titleOne }}</span>
    <TableUno :porcentajeIngreso="porcentajeIngreso" :readOnly="readOnly" />
    <span class="title">{{ titleTwo }}</span>
    <TableTwo
      :efectividad="efectividad"
      :porcentajeIngreso="porcentajeIngreso"
      :readOnly="readOnly"
    />
  </div>
</template>

<script>
import TableUno from "./components/TableUno.vue";
import TableTwo from "./components/TableTwo";
export default {
  props: ["porcentajeIngreso", "efectividad", "readOnly"],
  components: {
    TableUno,
    TableTwo,
  },

  data() {
    return {
      titleOne:
        "1.1 Porcentaje de ingresos a la contrata cubiertos por procesos de reclutamiento y selección",
      titleTwo: "1.2 Efectividad de la selección",
    };
  },
};
</script>

<style scoped>
.title {
  color: #052333;
  font-size: 17px;
  font-weight: bold;
  margin-top: 10px !important;
  margin-bottom: 10px;
}
</style>
